import React, { useContext, useState } from 'react';
import { View, Dimensions, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import { ContributionGraph } from 'react-native-chart-kit';

import { EVENT_COUNTS_BY_DAY } from './queries';

const EventsChart = ({ eventTypeId }) => {
  console.log(eventTypeId);
  const { data } = useQuery(EVENT_COUNTS_BY_DAY, {
    variables: { eventTypeId }
  });

  if (!data) { return null; }

  const chartConfig = {
    backgroundGradientFrom: "#ffffff",
    backgroundGradientTo: "#ffffff",
    color: (opacity = 1) => `rgba(102, 0, 204, ${opacity})`,
  };

  return (
    <ContributionGraph
      values={data.eventCountsByDay}
      endDate={new Date()}
      numDays={120}
      width={500}
      height={220}
      chartConfig={chartConfig}
    />
  );
};

export default EventsChart;
